import { render, staticRenderFns } from "./Estadistica.vue?vue&type=template&id=32b0eb96&"
import script from "./Estadistica.vue?vue&type=script&lang=js&"
export * from "./Estadistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports